import { render, staticRenderFns } from "./ManageCategories.vue?vue&type=template&id=80993f44&"
import script from "./ManageCategories.vue?vue&type=script&lang=js&"
export * from "./ManageCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports